const helperService = {
  title: "Helper",
  icon: "🤝",
  shortDescription:
    "Basic helper support for home, shifting, construction, and miscellaneous manual assistance.",
  longDescription:
    "Book helper support for simpler tasks, movement assistance, supervision help, and day-based execution support.",
  consultationNote:
    "Heavy, specialized, or skilled work should be booked under the correct service category instead.",
  responsePromise:
    "Assignment depends on task type, timing, and available helper pool.",
  warrantyPolicy:
    "Execution support category; revisit support depends on work context.",
  subServices: [
    {
      id: "helper-halfday",
      title: "Helper - Half Day",
      icon: "🤝",
      group: "Shift Support",
      description:
        "Helper support for 4-5 hours of basic manual assistance.",
      basePrice: 449,
      priceType: "fixed",
      duration: "4-5 hrs",
      warranty: "Execution support",
      unit: "shift",
    },
    {
      id: "helper-fullday",
      title: "Helper - Full Day",
      icon: "🤝",
      group: "Shift Support",
      description:
        "Helper support for full day miscellaneous home or site assistance.",
      basePrice: 699,
      priceType: "fixed",
      duration: "8-9 hrs",
      warranty: "Execution support",
      unit: "shift",
    },
    {
      id: "helper-item-movement",
      title: "Item Movement Support",
      icon: "📦",
      group: "Movement",
      description:
        "Support for moving smaller items, household goods, or light construction materials.",
      basePrice: 499,
      priceType: "starts_at",
      duration: "2-4 hrs",
      warranty: "Execution support",
      unit: "job",
    },
  ],
};

export default helperService;